export { default } from './SearchFormRedirect';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentMain/SearchFormRedirect/index.js